import { Datagrid, NumberField, ReferenceManyField, SimpleList, TextField } from "react-admin";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";

export const ProjectShowKarzanTab = () => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });
  return (
    <ReferenceManyField reference="projectKarzans" target="projectId" label={false}>
      {isSmall ? (
        <SimpleList
          primaryText={(r) => String(r.lenderName ?? "Karzan")}
          secondaryText={(r) =>
            `Principal ₹${Number(r.principalAmount ?? 0).toLocaleString("en-IN")} · Repaid ₹${Number(
              r.repaidAmount ?? 0
            ).toLocaleString("en-IN")}`
          }
          tertiaryText={(r) => String(r.status ?? "")}
          linkType="show"
          rowSx={() => ({ borderBottom: 1, borderBottomColor: "divider" })}
        />
      ) : (
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Datagrid bulkActionButtons={false} rowClick="show" sx={{ minWidth: 640 }}>
            <TextField source="lenderName" emptyText="—" />
            <NumberField
              source="principalAmount"
              options={{ style: "currency", currency: "INR" }}
            />
            <NumberField source="repaidAmount" options={{ style: "currency", currency: "INR" }} />
            <TextField source="status" />
          </Datagrid>
        </Box>
      )}
    </ReferenceManyField>
  );
};
